var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcFacebook = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#385C8E",
    d: "M7.351 12.717h2.387v9.928c0 .196.157.355.351.355h4.048c.194 0 .35-.159.35-.355v-9.881h2.745c.178 0 .329-.135.349-.314l.417-3.655c.011-.1-.02-.202-.087-.277-.067-.076-.162-.119-.262-.119h-3.161V6.11c0-.692.368-1.042 1.094-1.042h2.067c.194 0 .351-.159.351-.355V1.357c0-.196-.157-.354-.351-.354H14.8c-.02-.001-.065-.003-.13-.003-.495 0-2.213.098-3.57 1.36-1.503 1.397-1.294 3.07-1.244 3.36V8.4H7.351c-.194 0-.351.158-.351.354v3.608c0 .196.157.355.351.355z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-facebook.7ae9c516.svg";
export { ForwardRef as ReactComponent };